export default __webpack_public_path__ + "static/media/project3.79e0cc11.png";